import { CircularProgress } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import GradientPrimary from "../../components/gradient/GradientPrimary";
import GradientSecondary from "../../components/gradient/GradientSecondary";
import video1 from "../../media/videos/video1.mp4";
import video2 from "../../media/videos/video2.mp4";
import video3 from "../../media/videos/video3.mp4";
import { mainPlayerToggle } from "../../redux/actions/styles";
import MusicPlayer from "./MusicPlayer";

const Snap = (props) => {
  const { playSong, pauseSong, onChangeRange, toggleVolume, onClickPrev, onClickNext } = props;

  const dispatch = useDispatch();

  const snapRef = useRef(null);
  const musicPlayerRef = useRef(null);
  const videoRef = useRef(null);
  const hideActionsTimeoutRef = useRef(null);

  const [videoLengthCount, setvideoLengthCount] = useState(0);
  const [hideActions, sethideActions] = useState(false);
  const videoLength = 20;

  const [fullScreen, setfullScreen] = useState(false);
  const [expandScreen, setexpandScreen] = useState(false);

  const {
    play,
    currentSong: { video },
    currentSongList,
    currentSongIndex,
  } = useSelector((state) => state.player);

  useEffect(() => {
    dispatch(mainPlayerToggle(false));

    return () => {
      play && dispatch(mainPlayerToggle(true));
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [play, currentSongList, currentSongIndex]);

  useEffect(() => {
    function onKeyPress(e) {
      console.log(e.code);
      if (e.code === "ArrowLeft") {
        onClickPrev();
      }
      if (e.code === "ArrowRight") {
        console.log("right");
        onClickNext();
      }
      if (e.code === "Space") {
        play ? pauseSong() : playSong();
      }
      if (e.code === "Escape") {
        // fullScreen && setfullScreen(false);
        expandScreen && setexpandScreen(false);
      }
    }

    const snapScreen = snapRef.current;

    function onDoubleClick() {
      fullScreen ? exitFullScreen() : enterFullScreen();
    }

    function onFullScreenChange(e) {
      if (document.fullscreenElement) {
        setfullScreen(true);
      } else {
        setfullScreen(false);
        setexpandScreen(false);
      }
    }

    document.addEventListener("keydown", onKeyPress);
    snapScreen.addEventListener("dblclick", onDoubleClick);
    document.body.addEventListener("fullscreenchange", onFullScreenChange);

    return () => {
      document.removeEventListener("keydown", onKeyPress);
      snapScreen.removeEventListener("dblclick", onDoubleClick);
      document.body.removeEventListener("fullscreenchange", onFullScreenChange);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [playSong, fullScreen]);

  useEffect(() => {
    const interval = setInterval(() => {
      setvideoLengthCount(videoLengthCount + 1);
    }, 1000);

    if (videoLengthCount === videoLength) {
      videoRef.current.currentTime = 20;
      setvideoLengthCount(0);
    }

    return () => clearInterval(interval);
  }, [videoLengthCount]);

  useEffect(() => {
    setTimeout(() => {
      sethideActions(true);
    }, 6000);

    return () => {
      setfullScreen(false);
    };
  }, []);

  useEffect(() => {
    function onMouseMove(e) {
      if (hideActions) {
        sethideActions(false);
      } else {
        hideActionsTimeoutRef.current && clearTimeout(hideActionsTimeoutRef.current);

        hideActionsTimeoutRef.current = setTimeout(() => {
          sethideActions(true);
        }, 6000);
      }
    }

    document.addEventListener("mousemove", onMouseMove);

    return () => {
      document.removeEventListener("mousemove", onMouseMove);
    };
  }, [hideActions]);

  useEffect(() => {
    setvideoLengthCount(0);
    sethideActions(false);
    videoRef.current.src = video;
  }, [video]);

  async function enterFullScreen() {
    try {
      // element has entered fullscreen mode successfully
      await document.body.requestFullscreen();
      // setfullScreen(true);
    } catch (error) {
      // element could not enter fullscreen mode
      // setfullScreen(false);
    }
  }

  async function exitFullScreen() {
    try {
      // element has exited fullscreen mode
      await document.exitFullscreen();
      // setfullScreen(false);
    } catch (error) {
      // element could not exit fullscreen mode
      // setfullScreen(true);
      console.log(error.message);
    }
  }

  function enterExpandScreen() {
    setexpandScreen(true);
  }

  function exitExpandScreen() {
    setexpandScreen(false);
  }

  return (
    <div className={`snap ${fullScreen || expandScreen ? "full-screen" : ""}`} ref={snapRef}>
      <CircularProgress className="video-spinner" />
      <video ref={videoRef} autoPlay="autoplay" muted loop onLoadedMetadata={() => (videoRef.current.currentTime = 20)}>
        <source src={video} type="video/mp4" />
      </video>

      <div className="bg-dark" />
      {/* <GradientSecondary /> */}

      <MusicPlayer
        playSong={playSong}
        pauseSong={pauseSong}
        onChangeRange={onChangeRange}
        toggleVolume={toggleVolume}
        musicPlayerRef={musicPlayerRef}
        hideActions={hideActions}
        sethideActions={sethideActions}
        onClickPrev={onClickPrev}
        onClickNext={onClickNext}
        fullScreen={fullScreen}
        enterFullScreen={enterFullScreen}
        exitFullScreen={exitFullScreen}
        expandScreen={expandScreen}
        enterExpandScreen={enterExpandScreen}
        exitExpandScreen={exitExpandScreen}
      />
    </div>
  );
};

export default Snap;
